import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPartner = () => {
    const element = document.getElementById('partner');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 md:py-32 bg-white" data-id="element-38">
      <Container className="text-center max-w-4xl" data-id="element-39">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-[#2D2D2D] leading-tight mb-8" data-id="element-40">
          Strengthening fatherhood through reflection, presence, and community.
        </h1>
        <p className="text-xl md:text-2xl text-[#555555] leading-relaxed mb-12 max-w-2xl mx-auto font-light" data-id="element-41">
          We partner with schools and organizations to help fathers build
          lasting connections with their children through thoughtful, offline
          engagement.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-42">
          <Button onClick={scrollToPartner} size="lg" data-id="element-43">
            Partner With Us
          </Button>
          <a href="#mission" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#2D2D2D] hover:text-[#3D5A4C] transition-colors" data-id="element-44">
            Learn More
          </a>
        </div>
      </Container>
    </section>;
}